import { NumberInput, enforceNumber } from '../../../typing';

const enforceWithoutAcessors = <T extends object>(target: T, key: PropertyKey): void => {
  Object.defineProperty(target, key, {
    get() {
      return this[`_${key as string}`] as T;
    },
    set(value: NumberInput) {
      this[`_${key as string}`] = enforceNumber(value);
    },
    enumerable: true,
    configurable: true,
  });
};

/**
 * Decorator que força o valor de uma propriedade/método de classe para um valor numérico.
 *
 * @category Decorator
 *
 * @example
 * ```ts
 * import { EnforceNumber } from '@ids/tools';
 *
 * export class ExampleClass {
 *
 *   @EnforceNumber()
 *   quantity: number;
 *  }
 * }
 * ```
 */
export const EnforceNumber =
  (): PropertyDecorator =>
  (target: object, key: PropertyKey, propertyDescriptor?: PropertyDescriptor) => {
    if (!!propertyDescriptor?.set && !!propertyDescriptor) {
      const originalSetter = propertyDescriptor.set;

      propertyDescriptor.set = function (value: unknown) {
        originalSetter.call(this, enforceNumber(value));
      };

      return;
    }
    enforceWithoutAcessors(target, key);
  };
